/**
 * LOT-UI-02 — Session magasin unique (source de vérité).
 */
import { usePermissions } from '../contexts/PermissionsContext';

export function useActiveMagasin() {
  const {
    currentSessionMagasin,
    setSessionMagasin,
    allMagasins,
    getMagasinName,
    getMagasinColor,
    isSuper,
    isAdminMag,
    assignedMagasins,
  } = usePermissions();

  const code = currentSessionMagasin || null;
  const isAll = isSuper && !code;

  return {
    code,
    isAll,
    label: isAll ? 'Tous magasins' : (code ? `${code} — ${getMagasinName(code)}` : 'Choisir magasin'),
    color: code ? getMagasinColor(code) : '#10b981',
    setMagasin: setSessionMagasin,
    allMagasins,
    isSuper,
    isAdminMag,
    assignedMagasins,
  };
}

export default useActiveMagasin;
